import NoSsr from "@mui/material/NoSsr";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useItemTooltip, useMouseTracker } from "@mui/x-charts/ChartsTooltip";

import { Box } from "@mui/system";
import { generateVirtualElement } from "../../../../../ResuableChartTooltip/generateVirtualElement";

export function CustomItemTooltipBD({
  dataset,
  valueSuffix,
}: {
  dataset: any[];
  valueSuffix: string;
}) {
  const tooltipData: any = useItemTooltip();

  const mousePosition = useMouseTracker(); // Track the mouse position on chart.
  if (!tooltipData || !mousePosition) {
    // No data to display
    return null;
  }
  // The pointer type can be used to have different behavior based on pointer type.
  const isMousePointer = mousePosition?.pointerType === "mouse";
  // Adapt the tooltip offset to the size of the pointer.
  const yOffset = isMousePointer ? 0 : 40 - mousePosition.height;
  const dataIndex: any = tooltipData.identifier.dataIndex;

  const bdBy = tooltipData.label;

  const currentData = dataset?.[dataIndex];
  const clickIn = currentData?.[`click_in_${bdBy}`] ?? 0;

  return (
    <NoSsr>
      <Popper
        sx={{
          pointerEvents: "none",
          zIndex: (theme) => theme.zIndex.modal,
        }}
        open
        placement={isMousePointer ? "bottom" : "top"}
        anchorEl={generateVirtualElement(mousePosition)}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, yOffset],
            },
          },
        ]}
      >
        <Paper
          elevation={0}
          sx={{
            m: 1,
            p: 1.5,
            border: "solid",
            borderWidth: 0,
            borderColor: "divider",
            boxShadow: "0px 0px 3px #00000073",
            position: "relative",
          }}
        >
          <Stack spacing={0.5}>
            <Typography fontSize={15}>
              {bdBy}: {tooltipData.formattedValue}{" "}
              {valueSuffix === "%" ? "%" : ""}
            </Typography>
            <Typography fontSize={14}>Click In: {clickIn}</Typography>
          </Stack>

          <Box
            style={{
              position: "absolute",
              transform: "rotate(90deg)",
              top: "-10px",
              right: "45%",
              zIndex: "1",
              width: 0,
              height: 0,
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderRight: "8px solid #fff",
            }}
          />
        </Paper>
      </Popper>
    </NoSsr>
  );
}
